// src/pages/PrivacyPolicy.js

import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", fontFamily: "Arial, sans-serif", color: "#333" }}>
      <h1 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "20px" }}>Privacy Policy</h1>

      <p style={{ marginBottom: "16px" }}>
        Prabhat Tara Vidya Niketan ("we", "our", or "us") respects your privacy. This Privacy Policy describes how we collect, use, and protect your information when you interact with our website, app, or services, including those connected to Facebook Graph API.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>1. Information We Collect</h2>
      <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
        <li>Personal details: Name, email, phone number, etc.</li>
        <li>Facebook profile data (if logged in via Facebook): Name, email, profile picture, Facebook ID.</li>
        <li>Device and usage data: IP address, browser type, visited pages, time spent.</li>
      </ul>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>2. How We Use Your Information</h2>
      <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
        <li>To provide educational content and personalized services</li>
        <li>To connect you via Facebook for login or interaction with our pages/bots</li>
        <li>To improve our platform and services</li>
        <li>To communicate with you (e.g., updates, newsletters)</li>
      </ul>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>3. Facebook Data Usage</h2>
      <p style={{ marginBottom: "16px" }}>
        If you log in or interact with us via Facebook, we may access basic profile information (such as name, email, Facebook ID, and profile picture) through the Facebook Graph API. This data is used only to enhance your experience and is not shared with external parties without your consent.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>4. Sharing Your Information</h2>
      <p style={{ marginBottom: "16px" }}>
        We do not sell your personal data. We may share your information with trusted service providers who help us operate our services, and only when necessary (e.g., hosting, analytics).
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>5. User Control & Data Removal</h2>
      <p style={{ marginBottom: "16px" }}>
        You have full control over your Facebook-connected account. You can revoke access via your Facebook settings at any time. If you want your data deleted from our records, please contact us directly using the information below.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>6. Security</h2>
      <p style={{ marginBottom: "16px" }}>
        We take security seriously and implement appropriate measures to protect your data from unauthorized access, misuse, or disclosure.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>7. Children's Privacy</h2>
      <p style={{ marginBottom: "16px" }}>
        Our services are primarily for students and parents. We do not knowingly collect information from children under 13 without parental consent. If you believe your child has provided us information, please contact us immediately.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>8. Updates to This Policy</h2>
      <p style={{ marginBottom: "16px" }}>
        We may update this Privacy Policy periodically. Changes will be reflected on this page with a revised date.
      </p>

      <h2 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "10px" }}>9. Contact Us</h2>
      <p style={{ marginBottom: "8px" }}>If you have questions or concerns about this Privacy Policy, contact us:</p>
      <ul style={{ marginLeft: "20px", marginBottom: "30px" }}>
        <li>Email: principal@prabhatvidyanikethan.com</li>
        <li>Phone: +91 9939988606 / +91 7654164726</li>
        <li>Address: Rajkhand, Goraul, Vaishali, Bihar, India</li>
      </ul>

      <p style={{ fontSize: "14px", color: "#666" }}>Last Updated: April 2025</p>
    </div>
  );
};

export default PrivacyPolicy;
